//@ts-ignore
import React from 'react';
import PropTypes from 'prop-types';
import MaterialButton from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import themeUtils from 'commons/utils/theme';

const styles = (theme) => ({
  root: ({ color, variant, square, activeColor, noShadow }) => {
    const customColor = !themeUtils.isMaterialColor({ color }) ? color : null;
    if (variant === 'outlined') {
      return {
        borderColor: customColor ? customColor : '',
        color: customColor ? customColor : '',
        borderRadius: square ? 0 : '',
        '&:hover': {
          backgroundColor: customColor ? customColor : '',
          color: theme.palette.primary.main,
        },
        '&:disabled': {
          borderColor: customColor ? customColor : '',
          color: customColor ? customColor : '',
          opacity: customColor ? 0.4 : 1,
        },
      };
    }
    if (variant === 'contained') {
      return {
        boxShadow: noShadow ? 'none' : null,
        color: customColor ? theme.palette.getContrastText(customColor) : null,
        borderRadius: square ? 0 : null,
        backgroundColor: customColor ? customColor : null,
        '&:hover': {
          backgroundColor: activeColor ? activeColor : null,
          boxShadow: noShadow ? 'none' : null,
        },
        '&:disabled': {
          opacity: customColor ? 0.4 : 1,
          color: customColor ? theme.palette.getContrastText(customColor) : null,
          backgroundColor: customColor ? customColor : null,
        },
      };
    }
  },
});

const Button = ({
  title,
  startIcon,
  size,
  color,
  activeColor,
  noShadow,
  disabled,
  onClick,
  variant,
  children,
  fullWidth,
  square,
  classes,
  type,
  ...rest
}) => {
  return (
    <MaterialButton
      variant={variant}
      classes={classes}
      startIcon={startIcon}
      size={size}
      color={color}
      disabled={disabled}
      onClick={onClick}
      type={type}
      fullWidth={fullWidth}
      {...rest}
    >
      {children}
    </MaterialButton>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOfType(
    PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
    PropTypes.string,
  ),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  square: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
};

Button.defaultProps = {
  size: 'medium',
  color: 'default',
  disabled: false,
  onClick: null,
  variant: 'text',
  square: false,
  type: 'button',
};

export default withStyles(styles)(Button);
